import { getCookieItem } from 'utils/browserCache';
import { COOKIE_KEY } from 'constants/browserCache';
import { DataDogLogger } from 'utils/dataDog';
import { MojoContextMetaType } from '../types';

export const getPartnerMeta = (): MojoContextMetaType => {
  const partnerObjCookie = getCookieItem(COOKIE_KEY.PARTNER_OBJECT);
  const userAgent = navigator && navigator.userAgent ? navigator.userAgent : undefined;

  if (partnerObjCookie) {
    try {
      const { partnerKey, partnerId, partnerShortName, partnerLongName } =
        JSON.parse(partnerObjCookie);
      return {
        ...(userAgent && { user_agent: userAgent }),
        carvana_partner_id: partnerId ? String(partnerId) : undefined,
        carvana_partner_key: partnerKey ? String(partnerKey) : undefined,
        carvana_partner_short_name: partnerShortName,
        carvana_partner_long_name: partnerLongName,
      };
    } catch (e) {
      DataDogLogger.error(new Error('Error fetching partner metadata.'), e);
    }
  } else {
    /**
     * If PARTNER_OBJECT cookie does not exist (like in iOS app), assign fallback defaults.
     * In practice, it seems like every partner value from cookie is 'Carvana' anyway.
     * TODO - try to improve. Without this, will cause regression with chatContext on VDP (and maybe more).
     */
    const CARVANA_DEFAULT_PARTNER = 'Carvana';
    return {
      ...(userAgent && { user_agent: userAgent }),
      carvana_partner_id: '1',
      carvana_partner_key: CARVANA_DEFAULT_PARTNER,
      carvana_partner_short_name: CARVANA_DEFAULT_PARTNER,
      carvana_partner_long_name: CARVANA_DEFAULT_PARTNER,
    };
  }

  return {};
};
